import { HeroMetric, HeroMetricsContainer } from '../../components/display/hero-metrics';
import React from 'react';
import { getUnitName } from 'shared/src/domain/line-item/line-item-utils';
import { MediaPlanMetrics } from 'shared/src/domain/metrics/metrics-types';
import { ExecutionLineItemTrpcResponse } from 'shared/src/trpc-types/line-item-trpc-types';
import { adjustForCPMById } from '@/features/line-items/line-item-form/utils/line-item-form-utils';

type Props = { lineItem: ExecutionLineItemTrpcResponse; metrics: MediaPlanMetrics };

export function MediaPlanHeroMetrics({ lineItem, metrics }: Props) {
  return (
    <HeroMetricsContainer>
      <div className="flex justify-between gap-1">
        <HeroMetric
          primary={{
            name: `${getUnitName(lineItem.unit_price_type_name).full} Delivered`,
            value: metrics.actual_delivered_units,
            type: 'number'
          }}
          secondary={{
            type: 'percentage',
            name: 'Percent Delivered',
            value: metrics.percent_units_delivered
          }}
          tertiary={{
            type: 'currency',
            name: `${lineItem.unit_price_type_name} incurred`,
            value: adjustForCPMById(metrics.unit_cost_incurred, lineItem.unit_price_type_id)
          }}
        />
        <HeroMetric
          primary={{ name: 'Media Spend', value: metrics.actual_media_spend, type: 'currency' }}
          secondary={{
            type: 'currency',
            name: 'Revenue Earned',
            value: metrics.media_revenue_earned
          }}
        />
        <HeroMetric
          primary={{ name: 'Margin', value: metrics.current_margin, type: 'percentage' }}
          secondary={{
            type: 'margin',
            value: metrics.current_margin,
            target: metrics.target_margin
          }}
          tertiary={{ type: 'percentage', name: 'Target Margin', value: metrics.target_margin }}
        />
      </div>
    </HeroMetricsContainer>
  );
}
